import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.onscroll = function() {scrollFunction()};

    let navbar = document.getElementById("navbar");
    let header = document.getElementById("header");

    let sticky = navbar.offsetTop;

    function scrollFunction() {
      if (window.pageYOffset >= sticky * 2) {
        navbar.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky");
      }
    }
  }

}
